/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlaytimeByPlatform } from './PlaytimeByPlatform';
import {
    PlaytimeByPlatformFromJSON,
    PlaytimeByPlatformFromJSONTyped,
    PlaytimeByPlatformToJSON,
    PlaytimeByPlatformToJSONTyped,
} from './PlaytimeByPlatform';

/**
 * 
 * @export
 * @interface GetUserSummaryResponse
 */
export interface GetUserSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof GetUserSummaryResponse
     */
    totalXp?: number;
    /**
     * 
     * @type {number}
     * @memberof GetUserSummaryResponse
     */
    totalTime?: number;
    /**
     * 
     * @type {number}
     * @memberof GetUserSummaryResponse
     */
    totalGames?: number;
    /**
     * 
     * @type {PlaytimeByPlatform}
     * @memberof GetUserSummaryResponse
     */
    timeByPlatform?: PlaytimeByPlatform;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserSummaryResponse
     */
    isDevourPlayUser?: boolean;
}

/**
 * Check if a given object implements the GetUserSummaryResponse interface.
 */
export function instanceOfGetUserSummaryResponse(value: object): value is GetUserSummaryResponse {
    return true;
}

export function GetUserSummaryResponseFromJSON(json: any): GetUserSummaryResponse {
    return GetUserSummaryResponseFromJSONTyped(json, false);
}

export function GetUserSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalXp': json['totalXp'] == null ? undefined : json['totalXp'],
        'totalTime': json['totalTime'] == null ? undefined : json['totalTime'],
        'totalGames': json['totalGames'] == null ? undefined : json['totalGames'],
        'timeByPlatform': json['timeByPlatform'] == null ? undefined : PlaytimeByPlatformFromJSON(json['timeByPlatform']),
        'isDevourPlayUser': json['isDevourPlayUser'] == null ? undefined : json['isDevourPlayUser'],
    };
}

export function GetUserSummaryResponseToJSON(json: any): GetUserSummaryResponse {
    return GetUserSummaryResponseToJSONTyped(json, false);
}

export function GetUserSummaryResponseToJSONTyped(value?: GetUserSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalXp': value['totalXp'],
        'totalTime': value['totalTime'],
        'totalGames': value['totalGames'],
        'timeByPlatform': PlaytimeByPlatformToJSON(value['timeByPlatform']),
        'isDevourPlayUser': value['isDevourPlayUser'],
    };
}

